module.exports = "dist/logo_fire.png?608ff42c289ce195429aeffdf0c5fb74";